export default __webpack_public_path__ + "static/media/Deed of Contract_13.77432066.jpg";